import { togglePropsSchema } from '../component-catalog.js';
export const toggleDefinition = {
    type: 'Toggle',
    category: 'interactive',
    propsSchema: togglePropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Binary on/off switch. Props: checked?, label?.',
};
//# sourceMappingURL=Toggle.js.map